import { createSelector } from 'reselect';

import _ from 'lodash';
import type { State } from 'services/reducers/index';

export const selectOrderedCategories: (State) => Array<String> = createSelector(
  (state) => state.adminState.categories,
  (categories) => _.sortBy(categories, ['parentCategoryId', 'name'])
);
